import { inject, reactive, ref, provide, computed, watchEffect} from 'vue';

import Tooltip from '@/components/content/views/tooltip/tooltip.vue';


export default {
  name: 'ProgressBar',
  props: {
    lessons: {
      type: Array,
      required: true
    },
    expandedView: {
      type: Boolean,
      default: false,
    }
  },
  components: { 
    Tooltip, 
  },
  setup(props) {

    const config = inject('config');
    const authProvider = inject('authProvider');

    const state = reactive({
      showTooltip: false,
      allLessons: props.lessons,
      lessonsCompleted: computed(() => {
        let count = 0;
        props.lessons.forEach(lesson => {
          if(state.memberCompletedLessons.includes(lesson.id)) {
            count++;
          }
        });
        return count;
      }),
      percentage: computed(() => state.lessonsCompleted === 0 ? 0 : (state.lessonsCompleted / state.allLessons.length * 100) ),
      memberCompletedLessons: computed(() => authProvider().getCompletedLessons),
    });

    return {
      state
    }
  },
}